/* eslint-disable react-hooks/exhaustive-deps */

import { useEffect } from "react";
import { useAppStore } from "../../store/models/app";

function useKickstarted (p = {}) {
    const {
        onKickstarted = () => {},
    } = p;
    const appStore = useAppStore();
    
    useEffect(() => {
        if (!appStore.kickstarted) {
            appStore.gotoIndex();
        } else {
            onKickstarted();
        }
    }, []);

    useEffect(() => {
        if (appStore.kickstarted) {
            onKickstarted();
        }
    }, [appStore.observed.kickstarted]);

    return {
        appStore,
    };
}

export default useKickstarted;
